// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"73":"46afbbf7","522":"f03b600f"}[chunkId] + ".css";
};